import { withFormsy } from 'formsy-react';

export default function withFormsyValidations(
  WrappedComponent,
  validations,
  validationErrors,
) {
  const FormsyfiedComponent = withFormsy(WrappedComponent);

  return props => (
    <FormsyfiedComponent
      validations={validations ? validations(props) : undefined}
      validationErrors={validationErrors}
      {...props}
    />
  );
}
